import { Link } from 'react-router-dom';
import { MessageSquare, FileText, Calendar, CreditCard } from 'lucide-react';
import FAQs from '@/components/FAQs';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

const AccountSupport = () => {
  return (
    <div className="min-h-screen pt-24 pb-16 px-6">
      <div className="max-w-6xl mx-auto">
        {/* Quick Actions Header */}
        <div className="mb-12">
          <h1 className="text-3xl font-bold mb-6">Support & Resources</h1>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            <Card className="hover:shadow-md transition-shadow">
              <CardContent className="p-6">
                <Link to="/account" className="block group">
                  <div className="flex items-start gap-3">
                    <CreditCard className="w-5 h-5 text-primary mt-1" />
                    <div>
                      <h3 className="font-semibold group-hover:text-primary transition-colors">
                        Manage Billing
                      </h3>
                      <p className="text-sm text-muted-foreground mt-1">Update payment methods</p>
                    </div>
                  </div>
                </Link>
              </CardContent>
            </Card>

            <Card className="hover:shadow-md transition-shadow">
              <CardContent className="p-6">
                <Link to="/account" className="block group">
                  <div className="flex items-start gap-3">
                    <FileText className="w-5 h-5 text-primary mt-1" />
                    <div>
                      <h3 className="font-semibold group-hover:text-primary transition-colors">
                        View Contracts
                      </h3>
                      <p className="text-sm text-muted-foreground mt-1">Access signed agreements</p>
                    </div>
                  </div>
                </Link>
              </CardContent>
            </Card>

            <Card className="hover:shadow-md transition-shadow">
              <CardContent className="p-6">
                <Link to="/account/consulting" className="block group">
                  <div className="flex items-start gap-3">
                    <MessageSquare className="w-5 h-5 text-primary mt-1" />
                    <div>
                      <h3 className="font-semibold group-hover:text-primary transition-colors">
                        Buy Consulting
                      </h3>
                      <p className="text-sm text-muted-foreground mt-1">Expert domain guidance</p>
                    </div>
                  </div>
                </Link>
              </CardContent>
            </Card>

            <Card className="hover:shadow-md transition-shadow">
              <CardContent className="p-6">
                <a
                  href="https://attaindomains.com/book"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block group"
                >
                  <div className="flex items-start gap-3">
                    <Calendar className="w-5 h-5 text-primary mt-1" />
                    <div>
                      <h3 className="font-semibold group-hover:text-primary transition-colors">
                        Book a Call
                      </h3>
                      <p className="text-sm text-muted-foreground mt-1">Schedule time with us</p>
                    </div>
                  </div>
                </a>
              </CardContent>
            </Card>
          </div>
        </div>

        {/* Support FAQs */}
        <FAQs context="account" />
      </div>
    </div>
  );
};

export default AccountSupport;
